module.exports = __webpack_public_path__ + "assets/img/444.d08ef9b5.jpg";